import { STRUCTURE_TAG_COLORS } from '../constants/structureTagColors';

export const getTagElement = (
  name,
  required,
  type,
  placeholder,
  withEye = false,
) => ({
  name,
  required,
  children: [
    {
      type,
      name: '',
      placeholder,
    },
  ],
  withEye,
  color: required
    ? STRUCTURE_TAG_COLORS.REQUIRED
    : STRUCTURE_TAG_COLORS.OPTIONAL,
});
